export const apiUrl: string = "https://rickandmortyapi.com/api/character";
